<ng-container *ngIf="isOwner && isMap ; else load_map">
  <google-map 
    class="google-map" 
    [zoom]="zoom" 
    [center]="{ lat: latitude, lng: longitude }">
    
    <ng-container *ngIf="customerStartup && dealerDestination">
      <map-polyline [path]="[{ lat: customerStartup.lat, lng: customerStartup.lng }, { lat: dealerDestination.lat, lng: dealerDestination.lng }]" 
                    [options]="renderOptions">
      </map-polyline>
    </ng-container>
  </google-map>
</ng-container>

<ng-template #load_map>
  <div *ngIf="isMap">
    <google-map style="height: 500px;" [center]="{ lat: latitude, lng: longitude }" [zoom]="zoom">
      <map-marker [position]="{ lat: latitude, lng: longitude }"></map-marker>
    </google-map>
  </div>
</ng-template>

<ng-template #mapPopup let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Map Error!</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="prel">
      <p>{{errorMessage}}</p>
    </div>
  </div>
</ng-template>
